import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { Alert, CircularProgress, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DashboardQueries, DashboardsPage } from '@portal/app-admin'

function DashboardsErrorComponent() {
  const { t } = useTranslation('admin-console')
  return <Alert severity="error">{t('dashboards.table.error')}</Alert>
}

export const Route = createFileRoute('/_auth/preferences/dashboards')({
  component: DashboardsLayout,
  beforeLoad: ({ context: { scopedEnablements } }) => {
    if (!scopedEnablements.global().hasStandardEnablement('Dashboard', 'MANAGE')) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
  },
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(DashboardQueries.list())
  },
  pendingComponent: () => (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <CircularProgress />
    </Stack>
  ),
  errorComponent: DashboardsErrorComponent,
})

function DashboardsLayout() {
  return (
    <DashboardsPage>
      <Outlet />
    </DashboardsPage>
  )
}
